import { render, staticRenderFns } from "./StudioProductFreeMedia.vue?vue&type=template&id=0cc98da4&scoped=true&"
import script from "./StudioProductFreeMedia.vue?vue&type=script&lang=js&"
export * from "./StudioProductFreeMedia.vue?vue&type=script&lang=js&"
import style0 from "./StudioProductFreeMedia.vue?vue&type=style&index=0&id=0cc98da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc98da4",
  null
  
)

export default component.exports